import Link, { LinkTarget } from "./TextLink";
import ImageLink from "./ImageLink/ImageLink";

export default Link;
export { ImageLink, type LinkTarget };
